import { DEFAULT_LOCALE, LOCALE_PRESSURE_UNITS } from '../../constants';

export const getPressureUnit = (locale: string | undefined) => {
  return LOCALE_PRESSURE_UNITS[locale ?? DEFAULT_LOCALE] ?? 'hPa';
};
